<template>
  <!-- 대기실 및 채팅방 유저 목록 표시 -->
  <div>

    <transition name="slide" type="animation">
        <div class="menu-user"
            style="position:absolute;"
            v-show="ContextMenu"
            :style="{top:ContextMenuTop,left:ContextMenuLeft}"
        ><!--  v-on:mouseleave="hideContextMenu" -->
            <menu-user :userinfo='senduser'
            v-on:mouseleave="hideContextMenu"
            @request-mtm="requestmtm()"
            :roominfo="roominfo"            
            />

        </div>
    </transition>
    <div class="user-nametag" >
      <div class="user">
        
        <div class="profileImg" v-if="displayProfileImage">

          <div class="img" v-if="user.profile_photo_path"
           :style="{backgroundImage:`url(${user.profile_photo_url})`}"
          >
            <div v-if="owner || isOwner" class="mark"><img src="@/assets/imgs/chat/owner.gif"></div>
            <div v-if="manager || isManager" class="mark"><img src="@/assets/imgs/chat/manager.gif"></div>
          </div>
          <div class="img" v-else
             :style="{backgroundImage:`url(${require('@/assets/imgs/profile_blank.jpg')})`}"
          >
            <div v-if="owner || isOwner" class="mark"><img src="@/assets/imgs/chat/owner.gif"></div>
            <div v-if="manager || isManager" class="mark"><img src="@/assets/imgs/chat/manager.gif"></div>
          </div>
        </div>       
        <div class="userName" :style="lineheightstye" >
            <span class="nick" @click="viewMenu($event,user)">                  
                  <span v-if="user.level >=0 " class="level_icon">                   
                    <template v-if="user.role==='user'">                      
                      <img :src="`${require('@/assets/imgs/level/'+user.level+'.png')}`">                      
                    </template>
                    <template v-if="user.role==='admin' || user.role==='manager'">
                      <img :src="`${require('@/assets/imgs/level/m.png')}`"> 
                    </template>    
                    <template v-if="user.role!=='admin' && user.role!=='manager' && user.role!=='user'">
                      <img :src="`${require('@/assets/imgs/level/'+user.role+'.png')}`"> 
                    </template>                      
                  </span> {{user.nic?user.nic:user.from}}  
            </span>
            <span v-if="msg" class="msg">
                {{msg}}
            </span>
        </div>      

        <div class="myTalk" v-if="displaymytalk">
          <span >
            <!-- 손님입니다. -->

          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuUser from "@/components/users/MenuUser.vue";

export default {
  props:{
      user:{      },
      displaymytalk:{      },
      displayProfileImage:{      },
      lineheight:{      },
      msg:{},
      roominfo:{},
      owner:{},
      manager:{},
      managerInfo:{},
     
  },
  data(){
      return{
          ContextMenu:false,
          x:0,
          y:0,
          ContextMenuTop:'',
          ContextMenuLeft:'',
          senduser:'',
          lineheightstye:{}
      }
  },
  components:{
      MenuUser,

  },
  mounted(){
      // Listen to all clicks on the document
      // document.addEventListener("click", function(event)
      // {
      //     // 해당 클래스 네임을 클릭시는 팝업을 띄움
      //     if( event.target.classList !='nick' &&
      //     ( event.target.closest(".messages-container") || event.target.closest(".aside") )
      //     )//messages-container 부모영역일때만 클릭시 하이드
      //     {
      //         this.ContextMenu = false;
      //     }
      // }.bind(this));
      if(this.lineheight){
          this.lineheightstye ={
              lineHeight: 130 +'%',
              paddingLeft:0
          }
      }
  },
  computed:{
      isOwner(){
          if(this.roominfo && this.roominfo.user_id === this.user.id)           
          {
              return true;
          }else{
              return false;
          }
      },
      isManager(){
            if(this.roominfo && this.roominfo.manager.find((manager)=>manager.user_id === this.user.id))
          {
              return true;
          }else{
              return false;
          }
      }
  },
  methods:{
      viewMenu(event,user){
          // if(user.id ==0)
          // {
          //   alert('비회원으로 조회가 불가능합니다.');
          //   return;
          // }
          console.log(event);
          this.senduser =user;
          this.ContextMenuTop = (event.pageY-10)+'px';
          this.ContextMenuLeft = (event.clientX-10)+'px';
          this.ContextMenu = true;
      },
      hideContextMenu(){
          setTimeout(()=> {
              this.ContextMenu = false;
          }, 3000);
      },
      requestmtm()
      {
          this.Mtm = true;
      },
      confirm() {
            this.Mtm = false;
      },
      
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/ani_slide';
.user-nametag {
    line-height: 50px;
  .user {
    display: flex;
    .profileImg {
      width: 31px;
      height: 31px;
      padding: 10px;
      .img {
        background-color: #000;
        width: 31px;
        height: 31px;
        background-size:cover;
      }

      .mark{
        padding-top: 10px;
      }

    }
    
    .userName {
      font-weight: bold;
      font-size: 12px;
      //display: flex;
      padding-left: 20px;
      //flex: 1 1 auto;
      .nick{
        cursor:pointer;         
        //display: flex;
        //align-items: center;
        .level_icon{
         img{
           vertical-align: middle;
         }
        }
      }
    }
    .msg{
        padding-left: 10px;
        color:#545454;
        font-weight:normal;
    }
    .myTalk {
      font-size: 11px;
      color: #3e3e3e;
      padding-right: 10px;
    }
  }
}
</style>
